<template>
  <div class="commission-rank" ref="container">
    <div class="header">
      <!-- <div class="rank" v-if="position">
        您目前的排名为：第<span class="num">{{ position }}</span
        >名
      </div>
      <div class="rank" v-else>
        您暂未上榜
      </div> -->
    </div>
    <div class="wrapper">
      <div class="nav acea-row row-around">
        <div
          class="item navitem"
          :class="active === index ? 'font-color-orange' : ''"
          v-for="(item, index) in navList"
          :key="index"
          @click="switchTap(index)"
        >
          {{ item }}
        </div>
		<div class="navright">按销售排行</div>
      </div>
	  <div class="taptime">{{ time }}</div>
	  <div class="selfrankbox">
		  <div class="selfrank">
			  <img class="selfavatar" :src="oneself.avatar" alt="">
			  <div>
				  <p class="name">{{ oneself.nickname }}</p>
				  <p class="rank">排名：<strong>{{ oneself.ranking }}</strong> | 销售额：<strong>￥{{ oneself.brokerage_price }}</strong></p>
			  </div>
		  </div>
	  </div>
      <div class="list">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(item, index) in rankList"
          :key="index"
		  v-if="rankList.length > 0"
        >
          <div class="num" v-if="index <= 2">
            <img src="@assets/images/medal01.png" v-if="index == 0" />
            <img src="@assets/images/medal02.png" v-else-if="index == 1" />
            <img src="@assets/images/medal03.png" v-else-if="index == 2" />
          </div>
          <div class="num" v-else>{{ index + 1 }}</div>
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="item.avatar" /></div>
            <div class="text line1">{{ item.nickname }}</div>
          </div>
          <div class="people font-color-red">￥{{ item.brokerage_pricee }}</div>
        </div>
		
		
		<div v-if="rankList.length == 0">
			<img class="notfind" src="@assets/images/404.png" />
		</div>
      </div>
    </div>
	<Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<script>
import { getBrokerageRank } from "@api/user";
import { mapGetters } from "vuex";

const NAME = "CommissionRank";
export default {
  name: NAME,
  props: {},
  data: function() {
    return {
      navList: ["昨日","上周","上月"],
      active: 0,
      rankList: [],
      page: 1,
      limit: 10,
      type: "week",
      position: 0,
      loading: false,
      loaded: false,
	  time:"",
	  oneself:{}
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.loaded = false;
        this.page = 1;
        this.$set(this, "rankList", []);
        this.getBrokerageRankList();
      }
    },
    active() {
      this.loaded = false;
      this.page = 1;
      this.$set(this, "rankList", []);
      this.getBrokerageRankList();
    }
  },
  mounted: function() {
    this.getBrokerageRankList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getBrokerageRankList();
    });
  },
  methods: {
    switchTap: function(index) {
      this.active = index;
    },
    getBrokerageRankList: function() {
	  let that = this;
      if (this.loaded || this.loading) return;
      this.loading = true;
	  let time = "yesterday";
	  if(this.active === 0){time = "yesterday"}
	  if(this.active === 1){time = "last week"}
	  if(this.active === 2){time = "last month"}
      getBrokerageRank({
        page: this.page,
        limit: this.limit,
        time: time
      })
        .then(res => {
          let list = res.data.rank;
          that.rankList.push.apply(this.rankList, list);
          that.loading = false;
          that.loaded = list.length < this.limit;
          that.page++;
          that.time = res.data.time;
		  that.oneself = res.data.oneself;
          that.$set(this, "rankList", this.rankList);
          that.getUserRank();
        })
        .catch(error => {
          that.loading = false;
		  that.$dialog.message(error.msg);
		  setTimeout(function(){
		  	that.$router.push('/');  
		  },1000);
        });
    },
    getUserRank() {
      this.rankList.forEach((item, index) => {
        if (this.userInfo.uid == item.uid) this.position = index + 1;
      });
    }
  }
};
</script>
<style scoped>
.commission-rank .header {
  background: url("../../../assets/images/commission_bg.jpg") no-repeat;
  width: 100%;
  height: 3.44rem;
  background-size: 100% 100%;
  position: relative;
  z-index: -1;
}
.commission-rank .header .rank {
  font-size: 0.33rem;
  color: #fff;
  position: absolute;
  top: 1.6rem;
  left: 0.48rem;
}
.commission-rank .header .rank .num {
  font-size: 0.51rem;
  font-weight: bold;
  margin: 0 0.1rem;
}
.commission-rank .wrapper {
  width: 100%;
  background-color: #f5f5f5;
  border-radius: 0.2rem;
  margin: -0.25rem auto 0 auto;
}
.commission-rank .wrapper .nav {
  /* height: 0.99rem; */
  /* border-bottom: 0.025rem solid #f3f3f3; */
  font-size: 0.3rem;
  /* font-weight: bold; */
  /* color: #999; */
  /* line-height: 0.5rem; */
  /* justify-content: flex-start; */
  padding-top: 0.5rem;
}
.commission-rank .wrapper .nav .item.font-color-orange::after{
	content: "";
	display: block;
	margin: 0.05rem auto 0;
	width: 0.45rem;
	height: 0.05rem;
	border-radius: 3px;
	background-color: #f85;
}
/* .commission-rank .wrapper .nav .item.font-color-orange {
  border-bottom: 0.05rem solid #fd885c;
} */
.navright{float: right;color: #999;font-size: 0.26rem;font-weight: normal;width: 50%;text-align: right;}
.font-color-orange{
	color: #fd885c;
}
/* .navitem{
	margin-left: 0.45rem;
}
.navitem:first-child{
	margin-left: 0.2rem;
} */
.taptime{font-size: 0.26rem;color: #999;margin: 0.2rem;}
.commission-rank .wrapper .list {
  padding: 0 0.2rem;
  margin-top: 0.15rem;
}
.commission-rank .wrapper .list .item {
  /* border-bottom: 1px solid #f3f3f3; */
  height: 1.2rem;
  font-size: 0.28rem;
  background-color: #fff;
  padding: 0 0.2rem;
}
.commission-rank .wrapper .list .item .num {
  color: #666;
  width: 0.1rem;
  font-size: 0.36rem;
  font-weight: bold;
  margin-left: 0.1rem;
}
.commission-rank .wrapper .list .item .num.numberone{color: #d1bc94;}
.commission-rank .wrapper .list .item .num.numbertwo{color: #c8c9cc;}
.commission-rank .wrapper .list .item .num.numberthree{color: #e98c8d;}
.commission-rank .wrapper .list .item .num img {
  width: 0.34rem;
  height: 0.4rem;
  display: block;
}
.commission-rank .wrapper .list .item .picTxt {
  width: 3.5rem;
}
.commission-rank .wrapper .list .item .picTxt .pictrue {
  width: 0.68rem;
  height: 0.68rem;
}
.commission-rank .wrapper .list .item .picTxt .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 50%;
}
.commission-rank .wrapper .list .item .picTxt .text {
  width: 2.62rem;
  color: #333;
}
.commission-rank .wrapper .list .item .people {
  /* width: 1.75rem; */
  text-align: right;
}
.notfind{width: 80%;display: block;margin: 15% auto;}
.selfrankbox{padding: 0 0.2rem;margin-top: 0.2rem;}
.selfrank{background-color: #fff;padding: 0.2rem;display: flex;justify-content: flex-start;border-radius: 5px;}
.selfrank .name{font-size: 0.3rem;margin-top: -0.05rem;}
.selfrank .rank{font-size: 0.26rem;color: #999;margin-top: 0.05rem;}
.selfrank .rank strong{color: #333;font-size: 0.3rem;font-weight: normal;}
.selfavatar{width: 0.68rem;display: block;border-radius: 50%;height: 0.68rem;margin-right: 0.2rem;}
</style>